// extracted by mini-css-extract-plugin
export var compactFilters = "_gu-4";
export var detailImage = "_gu-1";
export var dropdownContainer = "_gu-2";
export var imageContainer = "_gu-0";
export var selectedCard = "_gu-3";